module.exports = __webpack_public_path__ + "static/media/logo185.e973a277.png";